const GoalEvent = ({ event, getPlayerName, getTeamAbbreviation }) => {
    const scoringPlayerId = event.details?.scoringPlayerId;
    const assist1PlayerId = event.details?.assist1PlayerId;
    const assist2PlayerId = event.details?.assist2PlayerId;
    const scoringPlayerName = getPlayerName(scoringPlayerId);
    const assist1PlayerName = getPlayerName(assist1PlayerId);
    const assist2PlayerName = getPlayerName(assist2PlayerId);
    const scoringPlayerTeamId = event.details?.eventOwnerTeamId;
    const scoringPlayerTeamAbbrev = getTeamAbbreviation(scoringPlayerTeamId);
    const scoringPlayerMugshotUrl = scoringPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${scoringPlayerTeamAbbrev}/${scoringPlayerId}.png` : null;
    const assist1PlayerMugshotUrl = assist1PlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${scoringPlayerTeamAbbrev}/${assist1PlayerId}.png` : null;
    const assist2PlayerMugshotUrl = assist2PlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${scoringPlayerTeamAbbrev}/${assist2PlayerId}.png` : null;

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
            <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
            <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">{scoringPlayerName}</span>
            {scoringPlayerMugshotUrl && (
                <img
                    src={scoringPlayerMugshotUrl}
                    alt={scoringPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 mx-2">Goal for</span>
            <span className="text-sm text-gray-900 mr-2">{scoringPlayerTeamAbbrev}</span>
            {assist1PlayerId && (
                <>
                    <span className="text-sm font-semibold text-gray-700 mx-2">Assisted by</span>
                    {assist1PlayerMugshotUrl && (
                        <img
                            src={assist1PlayerMugshotUrl}
                            alt={assist1PlayerName}
                            className="inline-block ml-2 w-8 h-8 rounded-full"
                        />
                    )}
                    <span className="text-sm font-semibold text-gray-700 ml-2">{assist1PlayerName}</span>
                </>
            )}
            {assist2PlayerId && (
                <>
                    <span className="text-sm font-semibold text-gray-700 mx-2">and</span>
                    {assist2PlayerMugshotUrl && (
                        <img
                            src={assist2PlayerMugshotUrl}
                            alt={assist2PlayerName}
                            className="inline-block ml-2 w-8 h-8 rounded-full"
                        />
                    )}
                    <span className="text-sm font-semibold text-gray-700 ml-2">{assist2PlayerName}</span>
                </>
            )}
        </div>
    );
};

export default GoalEvent;